import Services from "services";

const Mock = {
  get: (url, params) =>
    new Promise((res, rej) =>
      setTimeout(() => {
        switch (url) {
          case "/hrdu/penerimaan_petty_cash/page":
            res({
              data: {
                data: [
                  {
                    tgl_penerimaan_petty_cash: "2022-11-14",
                    no_penerimaan_petty_cash: "2022/02/HRDU/PNPC/000001",
                    tgl_bukti_mutasi: "2022-11-14",
                    no_bukti_mutasi: "2022/02/HRDU/PPC/000001",
                    nama_proyek: "laguna",
                    nominal_penerimaan_petty_cash: "2000000",
                    tgl_awal_petty_cash: "2022-11-14",
                    tgl_akhir_petty_cash: "2022-11-18",
                    sisa_masa_berlaku_petty_cash: "60 Hari",
                    status_approval: "PEN",
                  },
                ],
              },
            });
            break;

          case "/v1/example/single":
            res({
              data: {
                tanggal: "2020-01-01",
                keterangan: "",
                karyawan: Array.from({ length: 2 }).map((_, i) => ({
                  id: i + 1,
                  nama: `User ${i + 1}`,
                })),
                detail: Array.from({ length: 50 }).map((_, i) => ({
                  barang: `Barang ${i}`,
                  qty: i + 10,
                  harga: i + 1000,
                })),
              },
            });
            break;

          case "/v1/example/dropdown":
            res({
              data: Array.from({ length: 50 }).map((_, i) => ({
                id: i,
                nama: `User ${i}`,
              })),
            });
            break;
          default:
            res({});
        }
      }, 500)
    ),
  post: (url, params) =>
    new Promise((res, rej) => setTimeout(() => res("berhasil"), 500)),
  patch: (url, params) =>
    new Promise((res, rej) => setTimeout(() => res("berhasil"), 500)),
  put: (url, params) =>
    new Promise((res, rej) => setTimeout(() => res("berhasil"), 500)),
  delete: (url, params) =>
    new Promise((res, rej) => setTimeout(() => res("berhasil"), 500)),
};

class PenerimaanPettyCashApi {
  async getList(params) {
    const fetch = await Services("/hrdu/penerimaan_petty_cash/page", {
      params,
    });
    return fetch.data;
  }

  async getListMutasi(params) {
    const fetch = await Services("/hrdu/penerimaan_petty_cash/list_mutasi", {
      params,
    });
    return fetch.data;
  }

  async getSingle(params) {
    const fetch = await Services("/hrdu/penerimaan_petty_cash/single/", {
      params,
    });
    return fetch.data;
  }

  async getSingleMutasi(params) {
    const fetch = await Services("/hrdu/penerimaan_petty_cash/single_mutasi/", {
      params,
    });
    return fetch.data;
  }

  showHide(data) {
    return Services.put("/hrdu/penerimaan_petty_cash/toggle", data);
  }

  generateNumber(params) {
    return Services.get("/hrdu/penerimaan_petty_cash/no_baru", { params });
  }

  async getDropdownUnitProduksi() {
    const fetch = await Services.get(
      "/hrdu/pengajuan_petty_cash/unit_produksi_available"
    );
    return fetch?.data?.data?.map((val) => ({
      label: val.nama_unit_produksi,
      value: val.id_unit_produksi,
      limit_petty_cash: val.limit_petty_cash,
      id_penerima_petty_cash: val.id_penerima_petty_cash,
      id_pekerja: val.id_pekerja,
    }));
  }

  async getDropdownStatusApproval() {
    return [
      { label: "PENDING", value: "PEN" },
      {
        value: "VER",
        label: "VERIFIED",
      },
      {
        value: "APP",
        label: "APPROVED",
      },
      {
        value: "REV",
        label: "REVISI",
      },
      {
        value: "REJ",
        label: "REJECT",
      },
    ];
  }

  create(data) {
    return Services.post("/hrdu/penerimaan_petty_cash", data);
  }

  update(data) {
    return Services.put("/hrdu/penerimaan_petty_cash", data);
  }

  upload(data) {
    return Services.post("/hrdu/upload/penerimaan_petty_cash", data);
  }
}

export default new PenerimaanPettyCashApi();
